import { OverflowTooltip } from '@/common/components/ui/OverflowTooltip';

export const MultiTextCell = ({ value }: { value?: string[] }) => {
  if (!value?.length) {
    return null;
  }

  return (
    <OverflowTooltip
      tooltipContent={<span className="whitespace-pre-wrap">{value.join('\n')}</span>}
    >
      {value.join(', ')}
    </OverflowTooltip>
  );
};
